import { Injectable } from "@angular/core";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { first } from "rxjs/operators";
import { AuthenticationService } from "../_services/authentication.service";
import { UserService } from "../_services/user.service";
import { UrlParametersService } from "../_services/url-parameters.service";

declare let gtag: Function;
@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private urlParametersService: UrlParametersService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const loginUrlParams = this.urlParametersService.getLoginParameters(route);
    const params = this.urlParametersService.getUrlParameters(route);


    const currentUser = this.authenticationService.currentUserValue;
    if (
      !loginUrlParams[1] &&
      currentUser &&
      !this.authenticationService.isTokenExpired()
    ) {
      // authorised so return true
      gtag("set", "user_properties", {
        user_ID: currentUser.id,
        user_slug: btoa(currentUser.name),
        user_type: currentUser.type,
        company_key: currentUser.companyKey,
        group_key: currentUser.groupKey,
      });
      return true;
    }

    const authTokenUrlParamKey = loginUrlParams[0];
    const authTokenParamValue = loginUrlParams[1];

    if (!!authTokenParamValue && !!authTokenUrlParamKey) {
      this.authenticationService
        .authenticate(authTokenParamValue, authTokenUrlParamKey)
        .pipe(first())
        .subscribe({
          next: (result) => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            this.authenticationService.currentUserValue = result.data;
            if (
              params.lat != null ||
              params.long != null ||
              params.zoom != null ||
              params.address !== null
            ) {
              this.router.navigate(["app/home"], { queryParams: params });
            } else {
              const returnUrl = this.route.snapshot.queryParamMap.get(
                "returnUrl",
              )
                ? this.route.snapshot.queryParamMap.get("returnUrl")
                : "app/home";
              this.router.navigate([returnUrl]);
            }
          },
          error: (error) => {
            this.authenticationService.redirectToLogin(params, state.url);
          },
        });
    } else {
      this.authenticationService.redirectToLogin(params, state.url);
    }
    return false;
  }
}
